// src/pages/LoginPage.jsx
import LoginForm from "../LoginForm";

export default function LoginPage() {
  return <LoginForm />;
}
